import React, { useState,useCallback } from 'react';
import { Box, Typography, Button, Paper } from '@mui/material';
import { useDropzone } from 'react-dropzone';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';

const FileUploadBox = ({
  label,
  file,
  onFileChange,
  existingFileName,
  existingFileUrl,
  error: parentError,
  inputId,
}) => {
    const [localError, setLocalError] = useState(parentError);

  const onDrop = useCallback(
    (acceptedFiles) => {
      if (acceptedFiles.length > 0) {
        onFileChange(acceptedFiles[0]);
        setLocalError(null); // Clear error on valid file selection
      }
    },
    [onFileChange]
  );

    // Use effect to update local error if the parent error changes
  React.useEffect(() => {
    setLocalError(parentError);
  }, [parentError]);

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    multiple: false,
    accept: {
      'text/html': ['.html', '.htm'],
      'image/*': ['.png', '.jpg', '.jpeg', '.svg'],
    },
  });

  return (
    <Box sx={{ mb: 3 }}>
      <Typography variant="subtitle1" sx={{ mb: 1 }}>
        {label}
      </Typography>

      <Paper
        variant="outlined"
        {...getRootProps()}
        sx={{
          p: 2,
          textAlign: 'center',
          borderStyle: 'dashed',
          borderColor: isDragActive ? 'primary.main' : 'grey.400',
          backgroundColor: isDragActive ? 'grey.100' : 'inherit',
          cursor: 'pointer',
        }}
      >
        <input {...getInputProps()} id={inputId} />
        <CloudUploadIcon color="action" sx={{ fontSize: 40, mb: 1 }} />
        {file ? (
          <>
            <Typography variant="body2">{file.name}</Typography>
            <Typography variant="caption" color="textSecondary">
              (Click or drag to replace)
            </Typography>
          </>
        ) : (
          <Typography variant="body2" color="textSecondary">
            Drag & drop a file here, or click to select
          </Typography>
        )}
      </Paper>

      {existingFileName && existingFileUrl && (
        <Box
          sx={{
            mt: 1.5,
            textAlign: 'center',
            wordBreak: 'break-word',
          }}
        >
          <Typography
            variant="body2"
            sx={{ fontWeight: 500 }}
          >
            Current:
          </Typography>
          <Typography variant="body2" color="primary">
            <a
              href={existingFileUrl}
              target="_blank"
              rel="noopener noreferrer"
              style={{
                color: 'inherit',
                textDecoration: 'underline',
                wordBreak: 'break-word',
              }}
            >
              {existingFileName}
            </a>
          </Typography>
        </Box>
      )}

      {localError && (
        <Typography color="error" variant="caption" sx={{ mt: 1, display: 'block', textAlign: 'center' }}>
          {localError}
        </Typography>
      )}
    </Box>
  );
};

export default FileUploadBox;
